import {
  Box,
  Text,
} from '@chakra-ui/react';
import Chart from 'react-apexcharts';
import { useRecoilValue } from 'recoil';
import { selectedStateHighwaysSubnetworkState } from '@transport-insights/uikit';
import { useStateHighwaysPotholeRepairsHnoData } from '@src/modules/performance/context/reports-api-hooks';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Regions',
  content: [
    {
      title: '% completed within 24 hours',
      description:
  <Text fontSize="inherit">
    The year to date percentages of potholes on state highways within each Region that were repaired within 24 hours.
  </Text>,
      source: <Text fontSize="inherit" as="span">Sourced from NZTA</Text>,
    },
  ],
};

function StateHighwaysPotholeRepairsRegions() {
  const selectedSubnetwork = useRecoilValue(selectedStateHighwaysSubnetworkState);

  // Chart data
  const { data: hnoChartData, isLoading } = useStateHighwaysPotholeRepairsHnoData();
  const regionsLockYear = hnoChartData?.[0];

  return (
    <ReportSection
      title="Regions"
      isLoading={isLoading}
      lockYear={regionsLockYear?.lockYear}
      quarter={regionsLockYear?.quarter}
      quarterFormat="ytd"
      informationSource={informationSource}
      width="100%"
    >
      <Box w="100%">
        <Chart
          options={
            {
              chart: {
                animations: {
                  enabled: false,
                },
              },
              title: { text: 'Target of 90% completed within 24 hours' },
              dataLabels: {
                enabled: false,
              },
              legend: {
                show: true,
                position: 'top',
              },
              stroke: {
                width: 0,
              },
              yaxis: [
                {
                  min: 50,
                  max: 100,
                  title: {
                    text: '% completed within 24 hours',
                  },
                  labels: {
                    formatter(val) {
                      return `${val.toFixed(0)}%`;
                    },
                  },
                },
              ],
              xaxis:
                {
                  labels: {
                    show: true,
                    rotate: -45,
                    hideOverlappingLabels: false,
                  },
                },
              tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                marker: {
                  show: false,
                },
                y: {
                  formatter(val) {
                    return `${val.toFixed(0)}%`;
                  },
                },
              },
              plotOptions: {
                bar: {
                  distributed: false,
                  horizontal: false,
                },
              },
              annotations: {
                yaxis: [
                  {
                    y: 90,
                    strokeDashArray: 6,
                    borderWidth: 2,
                    borderColor: CHART_COLOURS.black,
                    width: '110%',
                    offsetX: -5,
                  },
                ],
              },
            }
          }
          series={[{
            name: 'Potholes repaired within 24 hours',
            data: hnoChartData?.filter((x) => x.onrcGroup === 'CompletionPercentAchieved' && x.subNetworkName !== 'Total')
              .map((item) => ({
                x: item.subNetworkName,
                y: item.percentAchievedYtd,
                fillColor: item.subNetworkId === selectedSubnetwork ? CHART_COLOURS.orange : CHART_COLOURS.darkblue,
              })) || [],
          }]}
          type="bar"
          width="100%"
          height="350"
        />
      </Box>
    </ReportSection>
  );
}

export default StateHighwaysPotholeRepairsRegions;
